<template>
      <div v-show="showVue" style="width:1300px;margin:0 auto;font-size:13px;">
           <div class="card mb-5 p-2" style="box-shadow: 10px 10px 5px #888888;margin-top:30px;">
                <p class="text-center mb-2">
                     <span style="font-size:20px;">
                       区域销售明细
                     </span>
                      <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                      </span>
                </p>
             <div style="text-align:left;" class="mb-3 mt-3">
                    <button class="btn btn-info" :class="{active_kan:kanlog==0}" @click="anhui()">
                         安徽
                    </button>
                    <button class="btn btn-info" :class="{active_kan:kanlog==1}" @click="yaocaigongsi()">
                         药材公司区域
                    </button>
                    <button class="btn btn-info" :class="{active_kan:kanlog==2}" @click="yaopinggongsi()">
                         药品公司区域
                    </button>
                    <button class="btn btn-info" :class="{active_kan:kanlog==3}" @click="gongyegongsi()">
                         工业公司
                    </button>
                    <button class="btn btn-info" :class="{active_kan:kanlog==4}" @click="xingteyao()">
                         新特药公司
                    </button>
                    <button class="btn btn-info" :class="{active_kan:kanlog==5}" @click="xiyao()">
                         西药公司
                    </button>
                     <span style="margin-left:400px;">

                                        <button class="btn btn-info" :class="{active_kan:time==0}" @click="shengDay()">当天</button>
                                        <button class="btn btn-info" :class="{active_kan:time==1}" @click="shengMonth()">当月</button>
                                        <button class="btn btn-info" :class="{active_kan:time==2}" @click="shengYear()">当年</button>
                     </span>
               </div>
                
                    <table v-if="showPage" class="table table-striped table-hover" ref="print">
                        <thead>
                                <tr style="white-space: nowrap;">
                                     <th class="text-center">省份</th>
                                     <th class="text-center">公司/客户数</th>
                                     <th class="text-center">药房/客户数</th>
                                     <th class="text-center">医疗机构/客户数</th>
                                     <th class="text-center">其他/客户数</th>
                                     <th class="text-center">合计</th>
                                     <th class="text-center">操作</th>
                               </tr>
                        </thead>
                        <tbody>
                                 <tr v-for="(item,index) in showList" :key="index">
                                                            <td class="text-center jz_middle">{{item.provinceName}}</td>
                                                            <td class="text-center jz_middle">{{item.gongSi}}
                                                                
                                                                <span class="active_kan">
                                                                    /{{item.gongSiCount}}
                                                                </span>

                                                                </td>
                                                            <td class="text-center jz_middle">{{item.yaoFang}}
                                                                

                                                                <span class="active_kan">
                                                                   /{{item.yaoFangCount}}
                                                                </span>
                                                                  
                                                                </td>
                                                            <td class="text-center jz_middle">{{item.yiLiaoJiGou}}
                                                                
                                                                 <span class="active_kan">
                                                                   /{{item.yiLiaoJiGouCount}}
                                                                </span>
                                                                
                                                                
                                                            </td>
                                                            <td class="text-center jz_middle">{{item.qiTa}}
                                                                  
                                                                <span class="active_kan">
                                                                    /{{item.qiTaCount}}
                                                                </span>
                                                               
                                                                </td>
                                                            <td class="text-center jz_middle">{{item.amount}}</td>
                                                            <td class="text-center jz_middle">
                                                                  <button class="bg-primary button_zi heit" @click="getDetails(index)">市县明细</button>
                                                            </td>

                                 </tr>
                                                         <tr style='color:red;'>
                                                                <td class="text-center jz_middle">合计:</td>
                                                                <td class="text-center jz_middle">{{Amount.gongSiAmount}}
                                                                            <span class="active_kan">
                                                                                  /{{Amount.gongSiCountAmount}}
                                                                             </span>
                                                                </td>
                                                                <td class="text-center jz_middle">{{Amount.yaoFangAmount}}
                                                                              <span class="active_kan">
                                                                                  /{{Amount.yaoFangCountAmount}}
                                                                             </span>
                                                                </td>
                                                                <td class="text-center jz_middle">{{Amount.yiLiaoJiGouAmount}}
                                                                             <span class="active_kan">
                                                                                  /{{Amount.yiLiaoJiGouCountAmount}}
                                                                             </span>
                                                                </td>
                                                                <td class="text-center jz_middle">{{Amount.qiTaAmount}}
                                                                            <span class="active_kan">
                                                                                  /{{Amount.qiTaCountAmount}}
                                                                             </span>
                                                                </td>
                                                                <td class="text-center jz_middle">{{Amount.amountAmount}}</td>
                                                                <td class="text-center jz_middle"></td>
                                                            </tr>
                        </tbody>
                 </table>
                    <div v-else>

                        <img src="../../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">

                    </div>
                 <!-- <div>
                         <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                 </div> -->
           </div>



           <!-- 详情内容 -->
                     <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content" style="width:1200px;position:relative;top:50px;left:-150px;margin-bottom:50px;">
                                <div class="modal-header">
                                    <button type="button" class="close m-0 p-1" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>

                                </div>
                                <div class="modal-body">
                                    <p class="mb-3 text-center" style="font-size:20px;">市区域销售明细</p>
                                    <div class="mb-2">
                                        <button class="btn btn-info" :class="{active_kan:shitime==0}" @click="shiDay()">当天</button>
                                        <button class="btn btn-info" :class="{active_kan:shitime==1}" @click="shiMonth()">当月</button>
                                        <button class="btn btn-info" :class="{active_kan:shitime==2}" @click="shiYear()">当年</button>
                                    </div>
                                     <div class="card">
                                                    <table v-if="showCity" class="table table-striped table-hover">
                                                        <thead>
                                                            <tr style="white-space: nowrap;">
                                                                 <th class="text-center">城市</th>
                                                                    <th class="text-center">公司/客户数</th>
                                                                    <th class="text-center">药房/客户数</th>
                                                                    <th class="text-center">医疗机构/客户数</th>
                                                                    <th class="text-center">其他/客户数</th>
                                                                    <th class="text-center">合计</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                             <tr v-for="(item,index) in details" :key="index">
                                                                    <td class="text-center jz_middle">{{item.provinceName}}</td>
                                                                    <td class="text-center jz_middle">{{item.gongSi}}
                                                                           <span class="active_kan">
                                                                                /{{item.gongSiCount}}
                                                                            </span>
                                                                    </td>
                                                                    <td class="text-center jz_middle">{{item.yaoFang}}
                                                                              <span class="active_kan">
                                                                                    /{{item.yaoFangCount}}
                                                                               </span>
                                                                    </td>
                                                                    <td class="text-center jz_middle">{{item.yiLiaoJiGou}}
                                                                                <span class="active_kan">
                                                                                    /{{item.yiLiaoJiGouCount}}
                                                                                </span>
                                                                    </td>
                                                                    <td class="text-center jz_middle">{{item.qiTa}}
                                                                              <span class="active_kan">
                                                                                  /{{item.qiTaCount}}
                                                                             </span>
                                                                    </td>
                                                                    <td class="text-center jz_middle">{{item.amount}}</td>
                                                             </tr>
                                                              <tr style='color:red;'>
                                                                <td class="text-center jz_middle">合计:</td>
                                                                <td class="text-center jz_middle">{{summation.gongSiAmount}}
                                                                            <span class="active_kan">
                                                                                  /{{summation.gongSiCountAmount}}
                                                                            </span>
                                                                </td>
                                                                <td class="text-center jz_middle">{{summation.yaoFangAmount}}
                                                                            <span class="active_kan">
                                                                                  /{{summation.yaoFangCountAmount}}
                                                                             </span>
                                                                </td>
                                                                <td class="text-center jz_middle">{{summation.yiLiaoJiGouAmount}}
                                                                             <span class="active_kan">
                                                                                  /{{summation.yiLiaoJiGouCountAmount}}
                                                                             </span>
                                                                </td>
                                                                <td class="text-center jz_middle">{{summation.qiTaAmount}}
                                                                             <span class="active_kan">
                                                                                  /{{summation.qiTaCountAmount}}
                                                                             </span>
                                                                </td>
                                                                <td class="text-center jz_middle">{{summation.amountAmount}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                             <div v-else>
                                                    <img src="../../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">
                                             </div> 
                                        <!-- 分页 -->
                                     </div>
                               </div>
                            <div class="modal-footer">
                                    <button type="button" class="btn btn-default" data-dismiss="modal"><span aria-hidden="true"></span>关闭</button>
                            </div>
                            </div>
                        </div>
                    </div>

      </div>
</template>

<script>
import vPagination from "../../components/Pagination.vue";
export default {
      data(){
          return{
              amountList:[],
            
              kanlog:100,
              time:0,
              shitime:0,
              showPage:true,
              showCity:true,
              DateType:'',

              total:1, 
              display: 20, 
              current: 1, 


              showList:[],

              details:[],
              showVue:false,

              Province:"",
               
          }
      },
      components:{
           vPagination,
      },
    filters: {
      
   },
   computed:{
           		Amount: function() {
				var _proList = this.showList;
                var	gongSiAmount = 0,yaoFangAmount=0,yiLiaoJiGouAmount=0,qiTaAmount=0,amountAmount=0,
                 gongSiCountAmount =0,yaoFangCountAmount=0,yiLiaoJiGouCountAmount=0,qiTaCountAmount=0
				for (var i = 0, len = _proList.length; i < len; i++) {
					//总价累加
					gongSiAmount += _proList[i].gongSi;
					yaoFangAmount += _proList[i].yaoFang;
					yiLiaoJiGouAmount += _proList[i].yiLiaoJiGou;
					qiTaAmount += _proList[i].qiTa;
                    amountAmount += _proList[i].amount;
                    gongSiCountAmount +=_proList[i].gongSiCount;
                    yaoFangCountAmount +=_proList[i].yaoFangCount;
                    yiLiaoJiGouCountAmount +=_proList[i].yiLiaoJiGouCount;
                    qiTaCountAmount +=_proList[i].qiTaCount;

                }
			
				return {
					gongSiAmount: gongSiAmount.toFixed(2),
					yaoFangAmount: yaoFangAmount.toFixed(2),
					yiLiaoJiGouAmount:yiLiaoJiGouAmount.toFixed(2),
					qiTaAmount :qiTaAmount.toFixed(2),
                    amountAmount:amountAmount.toFixed(2),
                    gongSiCountAmount:gongSiCountAmount.toFixed(2),
                    yaoFangCountAmount:yaoFangCountAmount.toFixed(2),
                    yiLiaoJiGouCountAmount:yiLiaoJiGouCountAmount.toFixed(2),
                    qiTaCountAmount:qiTaCountAmount.toFixed(2)
				}
            },
            
              
           summation:function(){
                var _proList = this.details;
                var	gongSiAmount = 0,yaoFangAmount=0,yiLiaoJiGouAmount=0,qiTaAmount=0,amountAmount=0,
                 gongSiCountAmount =0,yaoFangCountAmount=0,yiLiaoJiGouCountAmount=0,qiTaCountAmount=0
				for (var i = 0, len = _proList.length; i < len; i++) {
					//总价累加
					gongSiAmount += _proList[i].gongSi;
					yaoFangAmount += _proList[i].yaoFang;
					yiLiaoJiGouAmount += _proList[i].yiLiaoJiGou;
					qiTaAmount += _proList[i].qiTa;
                    amountAmount += _proList[i].amount;
                    gongSiCountAmount +=_proList[i].gongSiCount;
                    yaoFangCountAmount +=_proList[i].yaoFangCount;
                    yiLiaoJiGouCountAmount +=_proList[i].yiLiaoJiGouCount;
                    qiTaCountAmount +=_proList[i].qiTaCount;
                }
			
				return {
					gongSiAmount: gongSiAmount.toFixed(2),
					yaoFangAmount: yaoFangAmount.toFixed(2),
					yiLiaoJiGouAmount:yiLiaoJiGouAmount.toFixed(2),
					qiTaAmount :qiTaAmount.toFixed(2),
                    amountAmount:amountAmount.toFixed(2),
                    gongSiCountAmount:gongSiCountAmount.toFixed(2),
                    yaoFangCountAmount:yaoFangCountAmount.toFixed(2),
                    yiLiaoJiGouCountAmount:yiLiaoJiGouCountAmount.toFixed(2),
                    qiTaCountAmount:qiTaCountAmount.toFixed(2)
                    
				}
           }

   },
      methods:{
          shiDay(){
              const that = this
              that.shitime=0
              that.Custanalysisdetail(1,that.Province);
          },
          shiMonth(){
              const that = this
              that.shitime=1
              that.Custanalysisdetail(2,that.Province);
          },
          shiYear(){
              const that = this
              that.shitime=2
              that.Custanalysisdetail(3,that.Province);
          },

          shengDay(){
              const that = this
              that.time=0
              that.kanlog=100
              this.custanalysismodel(1);
          },
          shengMonth(){
              const that = this
              that.time=1
              that.kanlog=100
              this.custanalysismodel(2);
          },
          shengYear(){
              const that = this
              that.time=2
              that.kanlog=100
              this.custanalysismodel(3);
          },

    getDetails(index){
        this.Province=this.showList[index].provinceName
        this.Custanalysisdetail(1,this.Province)
        $("#myModal").modal();
    
     },

          xiyao(){
             const that = this
              that.kanlog=5
              that.showList=[]
              that.amountList.forEach((item,index)=>{
                  if(item.provinceName=="新疆维吾尔自治区"||item.provinceName=="福建省"||item.provinceName=="吉林省"
                  ||item.provinceName=="浙江省"||item.provinceName=="甘肃省"||item.provinceName=="陕西省"||item.provinceName=="河北省"||item.provinceName=="山西省"
                  ){
                      that.showList.push(item)
                  }
              })
            //   console.log(that.showList)
          },

          xingteyao(){
                const that = this
              that.kanlog=4
              that.showList=[]
              that.amountList.forEach((item,index)=>{
                  if(item.provinceName=="河南省"||item.provinceName=="广东省"||item.provinceName=="海南省"
                  ||item.provinceName=="江苏省"||item.provinceName=="云南省"
                  ){
                      that.showList.push(item)
                  }
              })
            //   console.log(that.showList)
          },

          gongyegongsi(){
                const that = this
              that.kanlog=3
              that.showList=[]
              that.amountList.forEach((item,index)=>{
                  if(item.provinceName=="重庆市"||item.provinceName=="湖南省"||item.provinceName=="贵州省"
                  ||item.provinceName=="黑龙江省"||item.provinceName=="西藏自治区"
                  ){
                      that.showList.push(item)
                  }
              })
            //   console.log(that.showList)
          },

          yaopinggongsi(){
               const that = this
              that.kanlog=2
              that.showList=[]
              that.amountList.forEach((item,index)=>{
                  if(item.provinceName=="北京市"||item.provinceName=="天津市"||item.provinceName=="辽宁省"
                  ||item.provinceName=="四川省"||item.provinceName=="青海省"||item.provinceName=="江西省"
                  ){
                      that.showList.push(item)
                  }
              })
            //   console.log(that.showList)
               
          },

          yaocaigongsi(){
               const that = this
              that.kanlog=1
              that.showList=[]
              that.amountList.forEach((item,index)=>{
                  if(item.provinceName=="宁夏回族自治区"||item.provinceName=="山东省"||item.provinceName=="上海市"
                  ||item.provinceName=="湖北省"||item.provinceName=="内蒙古自治区"||item.provinceName=="广西壮族自治区"
                  ){
                      that.showList.push(item)
                  }
              })
            //   console.log(that.showList)
          },

          anhui(){
              const that = this
              that.kanlog=0
              that.showList=[]
              that.amountList.forEach((item,index)=>{
                  if(item.provinceName=="安徽省"){
                      that.showList.push(item)
                  }
              })
            //   console.log(that.showList)
          },

        custanalysismodel:async function(ShengDateType){
          const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'custanalysismodel',
          obj: JSON.stringify({
               DateType:ShengDateType,
          })
        })
        // console.log(res)
        if (res.isok) {
                  const obj = res.data;
                  this.showVue=true;
                  this.amountList = obj.rows;
                   if(this.amountList.length>0)
                    {
                        this.showPage=true;
                    }
                    else{
                        this.showPage =false;
                    }
                  this.showList=this.amountList;
              
             }
        
       },

        Custanalysisdetail:async function(shiDateType,Province){
          const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'Custanalysisdetail',
          obj: JSON.stringify({
               DateType:shiDateType,
               Province,
          })
        })
        // console.log(res)
        if (res.isok) {
                  const obj = res.data;
                  this.details=obj.rows;
                  if(this.details.length>0)
                    {
                        this.showCity=true;
                    }
                    else{
                        this.showCity =false;
                    }
             }
        
       },
        
      },
      created(){
          this.custanalysismodel(1);
      }
}
</script>

<style lang="less" scoped>
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.jz_middle{
   vertical-align:middle;
 }
 .span_close:hover{
       color:#3190e8;
 }
 .active_kan{
      color:red;
 }
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .heit{
    height:1.5rem;
  }
</style>




// WEBPACK FOOTER //
// src/pages/manager/RegionalSales.vue